import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick deletes entries from the CXML timeout map by publishing an event
 * to shared memory with the appropriate buyer cookie ID.
 */
export default class DeleteFromCXMLTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} buyerCookieId
     * @param {function()} forwardEvent
     */
    update($, [buyerCookieId], [forwardEvent]) {
        Service.publish('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CXML_BUYER_COOKIE_DELETE, buyerCookieId})
            .then(forwardEvent);
    }
}

registerBrick('0197c15194d3e9180b84', DeleteFromCXMLTimeoutMap);
